import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import doc                 from '@widesk-core/decorators/doc';

export default class WebsiteConfigModel extends WebsiteServiceModel {
	private declare _tsFilters: {
		'partial': string;
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'website': id;
		'reference': Website_WebsiteConfigReference;
		'category': id;
		'search': string;
	};

	static get path(): string {
		return 'website_configs/{?id}';
	}

	declare _tsSorts: {
		id: string;
		reference: string;
		category: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare reference: Website_WebsiteConfigReference;
	@doc.string declare value: string;
	@doc.string declare createdBy: string;
	@doc.string declare updatedBy: string;
	@doc.date declare createdAt: Dayjs;
	@doc.date declare updatedAt: Dayjs;
}